// extracted by mini-css-extract-plugin
export default {"backdrop":"SuccessModal_backdrop__BFB3F","modal":"SuccessModal_modal__rUGre","container":"SuccessModal_container__PvZdl","img45":"SuccessModal_img45__GrF7A"};